import {useTranslation} from 'react-i18next';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import _ from 'lodash';
import {setSnackbar} from '../../../../store/reducers/globals';
import {nextWorkflowStep, workflow} from '../../../../store/reducers/workflow';
import AgyleButton from '../../../../components/ui/buttons/agyleButton';
import {getSafeguardingValues} from '../formsUtil';
import PaediatricSafeguardingForm from './paediatricSafeguardingForm';
import {getConfig} from '../../../../util/configUtil';
import {WORKFLOW_OPTIONS} from '../../../../util/workflowUtil';

const PaediatricSafeguarding = (props) => {
    const {t} = useTranslation();
    const [safeguarding, setSafeguarding] = useState({});
    const dispatch = useDispatch();

    const [safeLevelIsSelected, setIsLevelSelected] = React.useState(false);
    const workflowData = useSelector(workflow);

    // Configs
    const safeguardingLevelMandatory = getConfig('safeguardingLevelMandatory', false);

    useEffect(() => {
        if (props.agyleDialogInsertButtons) {
            props.agyleDialogInsertButtons([
                <AgyleButton
                    variant="contained"
                    onClick={submit}
                    disabled={disabledSubmit() || props.disableSave}
                >
                    {t('Submit')}
                </AgyleButton>,
            ]);
        }
        if (props.onSubmitFunction) {
            props.onSubmitFunction(submit);
        }
        if (props.onDisableSubmit) {
            props.onDisableSubmit(disabledSubmit() || props.disableSave);
        }
    }, [safeguarding, props.disableSave]);

    const isValid = () => {
        if (!safeguardingLevelMandatory) return true;
        return safeLevelIsSelected;
    };

    const submit = () => {
        const valid = isValid();
        if (valid) {
            if (!_.isEmpty(safeguarding)) {
                if (props.onSave) props.onSave(safeguarding);
                if (props.onChange) props.onChange(safeguarding);
            }
            if (props.onClose) props.onClose();
            if (workflowData.type === WORKFLOW_OPTIONS.SAFEGUARDING)
                dispatch(nextWorkflowStep());
        } else {
            dispatch(setSnackbar({type: 'warning', message: 'Not all mandatory fields have been filled out.'}));
            return valid;
        }
    };

    const getSafeguardingValuesMiniForm = (paedSafeguarding) => {
        let sAll = getSafeguardingValues(props.patient);

        let sPaedsSafeguarding = paedSafeguarding[0]?.value?.safeguarding?.reasons?.safeguarding ? paedSafeguarding[0].value.safeguarding.reasons.safeguarding : [];

        return _.uniqWith([...sAll, ...sPaedsSafeguarding], _.isEqual);
    };

    const setSafeguardingData = (value) => {
        value.push({
            name: 'studies.mainScreenSafeguarding',
            value: getSafeguardingValuesMiniForm(value),
        });
        setSafeguarding(value);
    };

    const disabledSubmit = () => !_.isEmpty(safeguarding) && safeguarding[0].value.safeguarding.level !== 'green' && !safeguarding[0].value?.safeguarding?.reasons?.reason;

    return (
        <PaediatricSafeguardingForm
            patient={props.patient}
            save={setSafeguardingData}
            levelIsSelected={setIsLevelSelected}
            selected={props.selectedHistoryForm}
            parentForm={props.parentForm}
            clerkingObj={props.clerkingObj}
        />
    );
};
export default PaediatricSafeguarding;